"use client";

import { z } from "zod/v3";

const KEY = "nf-one-sign-in-email";
const TTL_MS = 30 * 60_000;
const storedSchema = z.object({
  email: z.string().email(),
  expires: z.number(),
});

/**
 * Carries the address someone just applied with to the sign-in page that
 * follows, so they don't type it twice.
 *
 * Session storage rather than the URL: an address in a query string lands in
 * browser history, analytics and request logs. It only fills the field in;
 * the emailed code is still what proves the address.
 */
export function rememberSignInEmail(email: string) {
  try {
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ email: email.trim(), expires: Date.now() + TTL_MS }),
    );
  } catch {
    /* Optional: the field just starts empty. */
  }
}

export function readSignInEmail(): string | undefined {
  try {
    const stored = storedSchema.safeParse(
      JSON.parse(sessionStorage.getItem(KEY) ?? "null"),
    );
    return stored.success && stored.data.expires > Date.now()
      ? stored.data.email
      : undefined;
  } catch {
    return undefined;
  }
}

export function clearSignInEmail() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* Storage is optional. */
  }
}
